import { TaskPriorityOptions } from 'shared/types/task-base';

import { Colors } from './types';

const priorityCheckboxColorMap: Record<TaskPriorityOptions, Colors> = {
  [TaskPriorityOptions.Low]: Colors.Info,
  [TaskPriorityOptions.Medium]: Colors.Warning,
  [TaskPriorityOptions.High]: Colors.Error,
  [TaskPriorityOptions.None]: Colors.Default,
};

// The color a task's checkbox renders with, given its linked-item color and
// priority. Exported so anything drawn alongside the checkbox can match it.
export const getTaskCheckboxColor = (
  color?: string,
  priority?: TaskPriorityOptions | null,
): Colors | string =>
  color ?? (priority ? priorityCheckboxColorMap[priority] : Colors.Default);
